import React from 'react'
import accounting from 'accounting'
import diff from 'deep-diff'
import {t} from '../../helpers/translate'
let config = require('config')

export default class UserChangeSuccessComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  getMessage() {
    var message;

    if (this.props.quote && this.props.quote.premium_difference === 0) {
      message = t('User details not affected')
    } else {
      message = t('User details have been saved')
    }
    return message
  }

  render() {
    return <div>{this.getMessage()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/components/common/UserChangeSuccessComponent.js